import { State } from 'flow/types/State';
import { userIsLoggedInToQueue } from 'flow/utils/pbx-utils';
import { createSelector } from 'reselect';
import {
    selectWaitingQueueItems,
    selectAllQueueMembers,
} from './queue-selectors';
import { selectOwnExtensionKey } from './ExtensionSelectors';
import { Map, List } from 'immutable';

const selectNumberOfCentionErrandsAwaitingActivityOwnedByUser = (
    state: State,
) => state.omnichannel.get('userOwnedErrandsAwaitingActivityCount', 0);

export const selectUserHasCentionFeature = (state: State) =>
    !!state.app.getIn(['extension', 'hasOmnichannelFeature']);

const selectNumberOfCentionErrandsInQueuesUsersIsLoggedInTo = createSelector(
    [
        selectAllQueueMembers,
        selectWaitingQueueItems,
        selectOwnExtensionKey,
        selectUserHasCentionFeature,
    ],
    (allQueueMembers, queueItems, ownExtensionKey, hasCentionFeature) => {
        if (!hasCentionFeature) return 0;
        let queuesUserIsLoggedInTo = Map();
        return (
            queueItems?.filter((queuedItem) => {
                if (!queuedItem.get('isOmnichannelErrand')) {
                    return false;
                }

                const queueKey = queuedItem.get('queueEntityKey');

                if (!queuesUserIsLoggedInTo.has(queueKey)) {
                    const queueMembers = allQueueMembers.get(queueKey, List());
                    const userIsLoggedIn = userIsLoggedInToQueue(
                        ownExtensionKey,
                        queueMembers,
                    );
                    queuesUserIsLoggedInTo = queuesUserIsLoggedInTo.set(
                        queueKey,
                        userIsLoggedIn,
                    );
                }

                return !!queuesUserIsLoggedInTo.get(queueKey);
            })?.size || 0
        );
    },
);

export const selectNumberOfCentionErrandsRelevantForUser = createSelector(
    [
        selectNumberOfCentionErrandsInQueuesUsersIsLoggedInTo,
        selectNumberOfCentionErrandsAwaitingActivityOwnedByUser,
        selectUserHasCentionFeature,
    ],
    (
        numberErrandsInQueues,
        numberErrandsAwaitingActivity,
        hasCentionFeature,
    ) => {
        if (!hasCentionFeature) return 0;

        return numberErrandsInQueues + numberErrandsAwaitingActivity;
    },
);
